import { createContext, useContext, useEffect, useState } from "react";

export const THEMES = [
  { key: "blue", label: "Bleu", hex: "#0284C7", primary: "200 98% 39%" },
  { key: "teal", label: "Sarcelle", hex: "#0D9488", primary: "174 84% 32%" },
  { key: "indigo", label: "Indigo", hex: "#4F46E5", primary: "244 75% 59%" },
  { key: "emerald", label: "Émeraude", hex: "#059669", primary: "160 94% 30%" },
  { key: "slate", label: "Ardoise", hex: "#475569", primary: "215 25% 34%" },
];

const ThemeCtx = createContext(null);
export const useTheme = () => useContext(ThemeCtx);

function buildCss() {
  return THEMES.filter((t) => t.key !== "blue").map((t) => `
    html[data-theme="${t.key}"]{--primary:${t.primary};--ring:${t.primary};}
    html[data-theme="${t.key}"] .bg-sky-600{background-color:${t.hex}!important}
    html[data-theme="${t.key}"] .hover\\:bg-sky-600:hover{background-color:${t.hex}!important}
    html[data-theme="${t.key}"] .text-sky-700,html[data-theme="${t.key}"] .text-sky-600{color:${t.hex}!important}
    html[data-theme="${t.key}"] .accent-sky-600{accent-color:${t.hex}}
  `).join("\n");
}

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => localStorage.getItem("pi_theme") || "blue");
  useEffect(() => {
    if (!document.getElementById("pi-theme-vars")) {
      const el = document.createElement("style");
      el.id = "pi-theme-vars";
      el.textContent = buildCss();
      document.head.appendChild(el);
    }
    document.documentElement.dataset.theme = theme;
  }, [theme]);
  const setTheme = (k) => { setThemeState(k); localStorage.setItem("pi_theme", k); };
  return <ThemeCtx.Provider value={{ theme, setTheme, themes: THEMES }}>{children}</ThemeCtx.Provider>;
}
